<template>
  <div class="history contents">
    <form-date-range @changeDate="changeDate" />
    <div class="list" v-if="withdraw.purchaseWithdrawList.length">
      <ul>
        <wrap-list-item
          v-for="(withdraw, index) in withdraw.purchaseWithdrawList"
          :key="index"
          :propsdata="withdraw"
        ></wrap-list-item>
      </ul>
      <ListPagination
        :pageNo="withdraw.pageNo"
        :totalPageCount="withdraw.totalPageCount"
        @changePage="handleChangePage"
      />
    </div>
    <contents-none
      v-else
      :noneText="$t('cancel.no_withdrawal_records_for_period')"
    ></contents-none>
  </div>
</template>

<script>
import FormDateRange from '@/views/base/FormDateRange'
import WrapListItem from '@/views/my/WrapListItem'
import ContentsNone from '@/views/base/ContentsNone'
import ListPagination from '@/views/my/ListPagination'
import { mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  components: {
    FormDateRange,
    WrapListItem,
    ContentsNone,
    ListPagination
  },
  computed: {
    ...mapGetters('my', ['withdraw'])
  },
  methods: {
    ...mapActions('my', ['getWithdrawList']),
    changeDate() {
      this.getWithdrawList({ reset: true, pageNo: 1 })
    },
    handleChangePage(pageNo) {
      window.scrollTo(0, 0)
      this.getWithdrawList({
        reset: false,
        pageNo
      })
    }
  },
  mounted() {},
  destroyed() {}
}
</script>

<style lang="scss">
.period {
  position: relative;
  padding: 12px 12px 10px 16px;
  margin-bottom: 10px;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  z-index: 99;
  dl {
    font-size: 11px;
  }
  dt,
  dd {
    display: inline-block;
  }
  dt::after {
    content: '|';
    display: inline-block;
    margin: 0 4px;
  }
  button {
    position: absolute;
    top: 11px;
    right: 16px;
    font-size: 11px;
    font-weight: bold;
    .icon {
      margin-top: -1px;
    }
  }
}
.periodRadio {
  padding-top: 9px;
  li {
    display: inline-block;
    width: 25%;
    padding: 0 4px 0 0;
    div {
      width: 100%;
      height: 24px;
    }
    label {
      width: 100%;
      height: 24px;
      line-height: 18px;
      font-size: 11px;
      color: #8b8b91;
      text-align: center;
      border: 1px solid #8b8b91;
      &::before {
        display: none;
      }
    }
    input[check='true'] + label {
      color: #6134f1;
      font-weight: bold;
      border-color: #6134f1;
    }
  }
  dl {
    font-size: 12px;
    padding: 16px 16px 14px;
  }
  dt {
    display: inline-block;
    width: 83px;
    color: #151721;
    .icon {
      margin: -1px 2px 0 0;
    }
  }
  dd {
    display: inline-block;
    width: calc(100% - 83px);
    color: #636376;
  }
}
.periodSelect {
  padding-top: 4px;
  li {
    display: inline-block;
    width: 50%;
    padding-right: 4px;
  }
  select {
    position: relative;
    width: 100%;
    height: 24px;
    padding: 0 0 0 9px;
    font-size: 11px;
    border: 1px solid #151721;
    appearance: none;
    -webkit-appearance: none;
    background: url('../../assets/images/set_icon.png') no-repeat right -942px;
    background-size: 100px;
    border-radius: 0;
    &::-ms-expand {
      display: none;
    }
  }
}
</style>
